import PhoneIcon from "../assets/icons/phone-icon.svg?react";
import EmailIcon from "../assets/icons/email-icon.svg?react";
import LocationOnIcon from "../assets/icons/location-icon.svg?react";


export const basicContactInfo = [
    {
        href: "tel:+381641644401",
        text: "+381 64 16 444 01",
        target: "_self",
        Icon: PhoneIcon,
    },
    {
        href: "mailto:office@bpcproject.com",
        text: "office@bpcproject.com",
        target: "_self",
        Icon: EmailIcon,
    },
];

export const addressContactInfo = [
    {
        href: "https://maps.app.goo.gl/rKrwwnvdXFtEj9hQ6",
        text: "Miće Popovića 25/1, 37000, Kruševac, Srbija",
        target: "_blank",
        Icon: LocationOnIcon,
    },
    {
        href: "https://maps.app.goo.gl/61aswdDSVXiFv5As7",
        text: "Bulevar Kralja Aleksandra I Karađorđevića 9(Savska), Beograd, Srbija",
        target: "_blank",
        Icon: LocationOnIcon,
    },
    {
        href: "https://maps.app.goo.gl/fUTrMzHETNDV4Lmy5",
        text: "Sestre Baković 18, Niš, Srbija",
        target: "_blank",
        Icon: LocationOnIcon,
    },
    {
        href: "https://maps.app.goo.gl/v68uioYJijVFArjMA",
        text: "Miloja Pavlovića 9/1, Kragujevac, Srbija",
        target: "_blank",
        Icon: LocationOnIcon,
    },
    {
        href: "https://maps.app.goo.gl/RSFXH1RJUgvYmwn99",
        text: "Aleksandar Stamboliyski Blvd 217, 1303 Sofia, Bulgaria",
        target: "_blank",
        Icon: LocationOnIcon,
    },
    {
        href: "https://maps.app.goo.gl/M5Bww5bXc3GUPNd66",
        text: "Bdin 2, 3703 Vidin, Bulgaria",
        target: "_blank",
        Icon: LocationOnIcon,
    },
];